import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Scan At Checkout</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
